var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "desktop-layout", class: { "no-sidebar": _vm.no_sidebar } },
    [
      _c("div", { staticClass: "sidebar" }, [_c("side-menu")], 1),
      _vm._v(" "),
      _c("div", { staticClass: "full-page" }, [
        _c("div", { staticClass: "main" }, [
          _c(
            "div",
            { staticClass: "main-header" },
            [_c("breadcrumb", { on: { toggle: _vm.toggleSidebar } })],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "main-content" }, [_c("router-view")], 1)
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-231d2977", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-231d2977","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layout/desktop-layout.vue
// module id = null
// module chunks = 